import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="request"
export default class extends Controller {
    async sendPostRequest({method = "PATCH", url="/", params = {}} = {}) {
        const csrfToken = document
            .querySelector("meta[name='csrf-token']")
            .getAttribute("content");

        await fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken,
                "Accept": "application/json"
            },
            body: JSON.stringify({ user_preference: params})
            })
    }

    async sendGetRequest({ url = "/", params = {} } = {}) {
        const requestUrl = new URL(url, window.location.origin)

        Object.entries(params).forEach(([key, value]) => {
            if (value === null || value === undefined) return

            if (Array.isArray(value)) {
                value.forEach(item => requestUrl.searchParams.append(key, item))
            } else {
                requestUrl.searchParams.set(key, value)
            }
        })

        const response = await fetch(requestUrl, {
            method: "GET",
            headers: {
            Accept: "application/json"
            }
        })

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`)
        }

        return response.json()
    }

    submitParentForm(event) {
        event.currentTarget.form.requestSubmit()
    }
}
